<template>
  <div>
    <DynamicComponent edc-id="polaris-person-price" framework="Vue" :edc-dev="edcDev" />
  </div>
</template>

<script>
export default {
  name: 'PersonPrice',
  data() {
    return {
      edcDev: window.__EDC__.options.dev,
    }
  },
}
</script>
